import { useEffect, useRef, Component } from "react";
import Lenis from "lenis";
import "@/App.css";
import sethLogo from "@/assets/seth-logo.png";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Problem from "@/components/Problem";
import Solution from "@/components/Solution";
import Products from "@/components/Products";
import Hospitality from "@/components/Hospitality";
import Audience from "@/components/Audience";
import HowItWorks from "@/components/HowItWorks";
import BeforeAfter from "@/components/BeforeAfter";
import About from "@/components/About";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    render() {
        if (this.state.error) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-bg text-ink p-8">
                    <p>Algo deu errado. Recarregue a página.</p>
                </div>
            );
        }
        return this.props.children;
    }
}

const Page = () => (
    <div className="grain bg-bg text-ink min-h-screen">
        <Header />
        <main>
            <Hero />
            <Marquee />
            <Problem />
            <Solution />
            <Products />
            <Hospitality />
            <Audience />
            <HowItWorks />
            <BeforeAfter />
            <About />
            <Faq />
            <FinalCta />
        </main>
        <Footer />
        <FloatingWhatsApp />
    </div>
);

function App() {
    const lenisRef = useRef(null);

    useEffect(() => {
        const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (reduced) return;

        const lenis = new Lenis({
            duration: 1.15,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
        });
        lenisRef.current = lenis;

        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);

        const onClick = (e) => {
            const a = e.target.closest('a[href^="#"]');
            if (!a) return;
            const hash = a.getAttribute("href");
            if (hash.length > 1 && document.querySelector(hash)) {
                e.preventDefault();
                lenis.scrollTo(hash, { offset: -72, duration: 1.4 });
            }
        };
        document.addEventListener("click", onClick);

        return () => {
            cancelAnimationFrame(raf);
            document.removeEventListener("click", onClick);
            lenis.destroy();
            lenisRef.current = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <Page />
        </ErrorBoundary>
    );
}

export default App;
